"use client"

import { LockOpen } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `LockOpenIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const LockOpenIcon = component(Icon)({ as: LockOpen })
